import { createBrowserHistory } from 'history'

import routes from './routes'

export default createBrowserHistory({
  basename: routes.basename,
})
